export const header = {
  TOPBAR_CONTACT: 'Fale Conosco',
  TOPBAR_CLIENT_TERMS: 'Termos de uso do cliente',
  TOPBAR_SUPPLIER_TERMS: 'Termos de uso do fornecedor',
  BREADCRUMB_HOME: 'Início',
  NOTIFICATIONS: 'Notificações',
  SHOPPING_BAG: 'Sacola de compras',
  SEARCH: 'Pesquisar',
  AVATAR_ALT: 'Avatar ',
  TYPE_WHAT_YOU_NEED: 'O que você busca?',
  SEARCH_PLACEHOLDER: 'Favor inserir um texto para a busca',
  WANT_TO_BE_SUPPLIER: 'Quero ser Fornecedor',
  BECOME_SUPPLIER: 'Tornar-se fornecedor',
  ENTER: 'Entre',
  CREATE_YOUR_ACCOUNT: 'Crie sua conta',
  CLIENT: 'Cliente',
  EDIT_COMPANY_PROFILE: 'Editar perfil empresa',
  VIEW_COMPANY_PROFILE: 'Ver perfil empresa',
  MY_DASHBOARD: 'Meu Painel',
  AFFILIATE_DASHBOARD: 'Painel do Afiliado',
  EDIT_PROFILE: 'Editar perfil',
  VIEW_PROFILE: 'Ver perfil',
  ALTERAR_SENHA: 'Alterar senha',
  EXIT: 'Sair',
  NO_NEW_NOTIFICATIONS: 'Não há novas notificações',
  VIEW_ALL: 'Ver todas',
  WANT_TO_BE_AFFILIATE: 'Quero ser um Afiliado Sebraeplace',
  BACK: 'Voltar',
  BREADCRUMB_CATALOG: 'Catálogo'
};
